export default __webpack_public_path__ + "static/media/spinner.d8272e65.gif";